export default __webpack_public_path__ + "static/media/ap.b2d46e87.png";